import Icon, { ICONSIZE } from '../../../../../../../presentation/components/Icon';
import calendarIcon from '../../../../../../assets/icons/svg/calendar.svg';
import checkmarkIcon from '../../../../../../assets/icons/png/3x/circle-check-info@3x.png';
import TableEntry from '../../TableEntry';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'tools/hooks/useMediaQuery';

const PriceGuarantee = () => {
  const isAboveXXS = useMediaQuery('(min-width: 376px)');
  const { t } = useTranslation();

  return (
    <TableEntry
      leftValues={[
        t('pageSummaryBasicServicesSectionLabelPriceGuaranteeTitle'),
        t('pageSummaryBasicServicesSectionLabelPriceGuaranteeContent')
      ]}
      startElement={<Icon iconSrc={calendarIcon} size={ICONSIZE.medium} alt="calendar icon" />}
      endElement={
        <Icon iconSrc={checkmarkIcon} size={ICONSIZE.small} centered alt="checkmark icon" />
      }
      additionalClassNames={isAboveXXS ? '' : 'px-0'}
    />
  );
};

export default PriceGuarantee;
